import React, {PureComponent} from "react";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface Props {
    message: JSX.Element;
    onRefresh: () => void;
}

export default class ErrorMessage extends PureComponent<Props> {
    render(): JSX.Element {
        return (
            <>
                <p className="text-danger text-center px-4">
                    {this.props.message}
                </p>
                <p className="mt-3 text-center">
                    <Button color="link" onClick={this.props.onRefresh}>
                        <FontAwesomeIcon icon="redo-alt"/>
                    </Button>
                </p>
            </>
        );
    }
}